import React, {Component} from 'react';
import {Button, List, Tab, Tabs} from '@material-ui/core';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";


const CityInfoMap = require("./CityInfo.json");


class CityTabs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cityTabIndex: 0
        };
    }

    _handleSelectCity(value) {

        this.props.onClick && this.props.onClick.call(this, value);
    }

    _handleChangeLocationTabIndex(index, e) {
        this.setState({cityTabIndex: index})
    }

    render() {
        const text = this.props.text;

        return (

                <div className="search-condition-tab-container">
                    <Tabs className="search-condition-tab"
                          orientation="vertical"
                          variant="standard"
                          value={this.state.cityTabIndex}
                          onChange={(e, index) => this._handleChangeLocationTabIndex(index, e)}
                        // aria-label="Vertical tabs example"
                        // className={classes.tabs}
                    >
                        {
                            Object.keys(CityInfoMap).map((key, index) => {
                                return <Tab key={key} label={key}/>

                            })
                        }</Tabs>

                    {
                        this.state.cityTabIndex === 0 ? this._renderHotCity() : this._renderCity()
                    }


                    {/*<List hidden={this.state.locationTabIndex !== 1} className="search-condition-tab-list">*/}
                    {/*{MapSearchRangeEnums.List.map((enumItem, index) => {*/}
                    {/*let selected = searchCondition && searchCondition.showRangeValue === enumItem.value;*/}
                    {/*return <ListItem button key={enumItem.value}*/}
                    {/*selected={selected}*/}
                    {/*onClick={() => this._handleChange("showRangeValue", enumItem.value)}>*/}
                    {/*<ListItemText primary={enumItem.label}/>*/}

                    {/*</ListItem>*/}
                    {/*})}*/}
                    {/*</List>*/}
                </div>

        );
    }

    _renderHotCity() {

        let cityTabIndex = this.state.cityTabIndex ? this.state.cityTabIndex : 0;
        let cityKey = Object.keys(CityInfoMap)[cityTabIndex];
        let cityContainerList = CityInfoMap[cityKey];
        return (<List className="search-condition-tab-list city-list">
            {cityContainerList.map((item, index) => {
                return (
                    Object.keys(item).map((region, regionIndex) => {
                        return (<div>
                            <div>{region}</div>
                            {
                                item[region].map((regionItem, regionItemIndex) => {
                                    return <Button type="link" key={regionItemIndex}
                                                   onClick={() => this._handleSelectCity(regionItem.value)}>{regionItem.title}</Button>

                                })
                            }
                        </div>)
                    }))
            })}

        </List>)
    }

    _renderCity() {
        let cityTabIndex = this.state.cityTabIndex ? this.state.cityTabIndex : 0;
        let cityKey = Object.keys(CityInfoMap)[cityTabIndex];
        let cityContainerList = CityInfoMap[cityKey];
        return <List className="search-condition-tab-list city-list">
            {
                cityContainerList.map((item, index) => {
                    return <Button type="link"
                                onClick={() => this._handleSelectCity(item.value)}>{item.title}</Button>

                })
            }

        </List>

    }

}
function mapStateToProps(store) {
    return {}
}
export default connect(mapStateToProps)(injectIntl(CityTabs));